// New memberships go above the saved order; existing manual positions stay intact.
export function reconcileServerOrder(saved:string[],memberships:string[]){
 const ids=[...new Set(memberships)],known=new Set(saved),active=new Set(ids);
 return [...ids.filter(id=>!known.has(id)),...new Set(saved.filter(id=>active.has(id)))];
}

export function moveServer(order:string[],id:string,target?:string,edge:'before'|'after'='before'){
 if(!order.includes(id)||id===target)return order;
 const next=order.filter(x=>x!==id);const index=target?next.indexOf(target):-1;
 next.splice(index<0?next.length:index+(edge==='after'?1:0),0,id);return next;
}

// Moves a whole block (e.g. all servers of a folder) before/after another block, keeping inner order.
export function moveBlock(order:string[],block:string[],target?:string[],edge:'before'|'after'='before'){
 const set=new Set(block),moving=order.filter(x=>set.has(x));if(!moving.length)return order;
 if(target?.some(x=>set.has(x)))return order;
 const rest=order.filter(x=>!set.has(x)),tset=new Set(target||[]);
 const idx=rest.map((x,i)=>tset.has(x)?i:-1).filter(i=>i>=0);
 const at=!idx.length?rest.length:edge==='after'?idx[idx.length-1]+1:idx[0];
 rest.splice(at,0,...moving);return rest;
}
